import React, { Component } from 'react'
import PurchaseButton from '../../../Global_Layouts/PurchaseButton/PurchaseButton'
import './Product_data.css'
import numeral from 'numeral';
import VariationsSelector from '../../../Global_Layouts/VariationsSelector/VariationsSelector';
import bestSeller from '../../../Assets/16902725561bbf1a4128275fa9bda56d25e07f08b6.png'
import Badget from '../../../components/Badgets/Badget';
import { BiCheckCircle, BiSolidHeart } from 'react-icons/bi';

export default class Product_data extends Component {

  addToCart = () => {
    const {add_to_cart, ProductData, selectedPackData, selectedVariants} = this.props
    add_to_cart({
      ProductData,
      selectedPackData,
      selectedVariants
    })
  }

  render() {
    const {readData, shoppingMoreThanOne, ProductData, getSelectedPackData, selectedVariants, getSelectedVariants, selectedPackId, selectedPackData, quantity, first_name, last_name, phone_number, address1, address2, province, city, contact_email, note, shipping_type_code } = this.props
    const {product_data_for_upsell} = this.props
    const {UTM_params, discount_code} = this.props
    const {resetAll, discount_value, setDiscountValue, setShowToast, min_qty_to_get_bulk_discount, free_shipping, shipping_cost, bulk_unit_discount, units, cart_items, add_to_cart, remove_from_cart} = this.props

    return (
      <div className='Product_data'>
        <div className='Product_data_title'>{ProductData.comodin_title}</div>
        
        <div className="Product_data_separator"></div>

        <div className='Product_data_discount'>{ Math.round(((ProductData.comodin_comparative_price - ProductData.comodin_price) / ProductData.comodin_comparative_price)*100 )}% DESCUENTO </div>

        <div className='Product_data_prices'>
            <div className='Product_data_price'>{numeral(ProductData.comodin_price).format('$ 0,0[.]00')}</div>
            <div className='Product_data_comparative_price'>{numeral(ProductData.comodin_comparative_price).format('$ 0,0[.]00')}</div>
        </div>


        <div className='lastUnits'>
            <img style={{width:"20px", height:"auto", marginRight:"6px", marginLeft:"6px"}} src={bestSeller} alt="" />
            {/* #{product_ciclo_id?.toString()?.charAt(product_ciclo_id.toString().length - 1)} Best Sellers - Ultimas unidades disponibles */}
            #1 Best Sellers - Ultimas unidades disponibles
        </div>
        <div className='moreComing'>
            Vienen más en camino
        </div>



        <div className="Product_data_separator"></div>

        {shoppingMoreThanOne===false?
        <VariationsSelector getSelectedVariants={getSelectedVariants} selectedVariants={selectedVariants} ProductData={ProductData}/>
        :null}

        <div className="Product_data_separator"></div>

        <div id='Product_data_purchase_btn'>
          <PurchaseButton
            animation_disabled={true}
            resetAll={resetAll}
            discount_value={discount_value} 
            setDiscountValue={setDiscountValue} 
            // setShowToast={(boolean)=>setShowToast(boolean)} 
            min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount} 
            free_shipping={free_shipping} 
            shipping_cost={shipping_cost} 
            bulk_unit_discount={bulk_unit_discount} 
            units={units} 
            from_cart={false} 
            cart_items={cart_items} 
            add_to_cart={add_to_cart} 
            remove_from_cart={remove_from_cart}
            
            discount_code={discount_code} UTM_params={UTM_params} product_data_for_upsell={product_data_for_upsell} getSelectedVariants={getSelectedVariants} selectedVariants={selectedVariants} ProductData={ProductData} readData={ readData } getSelectedPackData={getSelectedPackData} selectedPackId={selectedPackId} selectedPackData={selectedPackData} quantity={ quantity } first_name={ first_name } last_name={ last_name } phone_number={ phone_number } address1={ address1 } address2={ address2 } province={ province } city={ city } contact_email={ contact_email } note={ note } shipping_type_code={shipping_type_code}
          />
        </div>

        <div style={{marginTop:"10px"}}>
          <div onClick={()=>this.addToCart()} className='atc-product_data'>Agregar al carrito</div>
        </div>

        <div className='Badgets'>
          <Badget Icon={BiCheckCircle} regular_text={"Satisfacción"} bold_text={"garantizada"} />
          <Badget Icon={BiCheckCircle} regular_text={"Pagos"} bold_text={"contraentrega"} />
          <Badget Icon={BiSolidHeart} regular_text={"Envios"} bold_text={"gratis"} />
        </div>
        
      </div>
    )
  }
}
